// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lelkvenrjohimbwigxjp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxlbGt2ZW5yam9oaW1id2lneGpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgxNzkyNDQsImV4cCI6MjA1Mzc1NTI0NH0.G_4cUeV-R0UUAxYMRmgGWLG1t0ViEo-n9DnbbaPGJDA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);